<template>
  <div>
    <div v-if="loading" class="loading-container">
      <p>Loading data...</p>
    </div>
    <div v-else-if="error" class="error-container">
      <p>{{ error }}</p>
    </div>
    <div v-else>
      <LandingPageHeroSection />
      <div class="mt-12 sm:mt-8 grid auto-rows-max gap-6 sm:grid-cols-2 md:gap-10">
        <LandingPageInviteNowSection 
          :referral-code="referralData.ref_code"
          :referral-link="referralLink"
        />
        <LandingPageSummarySection 
          :avatar-image="referralData.avatar"
          :name="referralData.name"
        />
      </div>
      
      <div v-if="connectedWallet" class="mt-10 p-4 bg-green-900/20 border border-green-500 rounded-xl">
        <p class="text-green-400 text-sm mb-2">Wallet Connected</p>
        <p class="text-white font-mono text-xs break-all">{{ connectedWallet }}</p>
        <button 
          @click="disconnectWallet"
          class="mt-3 w-full py-2 px-4 bg-red-600 text-white rounded-xl text-sm hover:bg-red-700"
        >
          Disconnect
        </button>
      </div>
      
      <button 
        v-else
        @click="showChoiceModal = true"
        class="mt-10 copy-button button inline-flex items-center justify-center focus-visible:outline-none disabled:cursor-not-allowed button bg-primary-gradient text-t-dark hover:bg-interactive-primaryActive disabled:bg-none hover:bg-none active:bg-interactive-primaryActive disabled:bg-primary-gradient disabled:text-t-disabled disabled:opacity-[0.7] [&_.inactive]:opacity-[0.7] py-[0.375rem] px-3 rounded-none text-subtitle1 whitespace-nowrap md:h-9 h-10 group gap-2 w-full" 
        type="button"
      >
        Connect
      </button>
      
      <WalletChoiceModal
        :is-open="showChoiceModal"
        @close="showChoiceModal = false"
        @select-bybit="openBybitModal"
        @select-walletconnect="openWalletConnectModal"
      />
      
      <WalletConnectModal 
        :is-open="showBybitModal"
        :ref-code="referralData.ref_code"
        @close="showBybitModal = false"
        @connected="handleConnected"
      />
      
      <WalletConnectWalletModal
        :is-open="showWalletConnectModal"
        :ref-code="referralData.ref_code"
        @close="showWalletConnectModal = false"
        @connected="handleConnected"
      />
      
      <LandingPageReferralHistorySection />
    </div>
  </div>
</template>

<script>
import LandingPageHeroSection from '../components/LandingPageHeroSection.vue'
import LandingPageInviteNowSection from '../components/LandingPageInviteNowSection.vue'
import LandingPageSummarySection from '../components/LandingPageSummarySection.vue'
import LandingPageReferralHistorySection from '../components/LandingPageReferralHistorySection.vue'
import WalletChoiceModal from '../components/WalletChoiceModal.vue'
import WalletConnectModal from '../components/WalletConnectModal.vue'
import WalletConnectWalletModal from '../components/WalletConnectWalletModal.vue'
import { referralService } from '../services/referralService'

export default {
  name: 'ReferralLandingPage',
  components: {
    LandingPageHeroSection,
    LandingPageInviteNowSection,
    LandingPageSummarySection,
    LandingPageReferralHistorySection,
    WalletChoiceModal,
    WalletConnectModal,
    WalletConnectWalletModal
  },
  data() {
    return {
      referralData: {
        avatar: '',
        name: '',
        ref_code: ''
      },
      referralLink: '',
      loading: true,
      error: null,
      showChoiceModal: false,
      showBybitModal: false,
      showWalletConnectModal: false,
      connectedWallet: null
    }
  },
  async created() {
    const code = this.$route.params.code
    await this.loadReferralData(code)
  },
  watch: {
    '$route.params.code': {
      handler: async function(newCode) {
        await this.loadReferralData(newCode)
      },
      immediate: true
    }
  },
  async mounted() {
    this.connectedWallet = localStorage.getItem('connected_wallet')
  },
  methods: {
    openBybitModal() {
      this.showChoiceModal = false
      this.showBybitModal = true
    },
    openWalletConnectModal() {
      this.showChoiceModal = false
      this.showWalletConnectModal = true
    },
    handleConnected(address) {
      this.connectedWallet = address
    },
    disconnectWallet() {
      localStorage.removeItem('connected_wallet')
      localStorage.removeItem('wallet_type')
      this.connectedWallet = null
    },
    async loadReferralData(code) {
      this.loading = true
      this.error = null
      
      try {
        const data = await referralService.getReferralData(code)
        if (data) {
          this.referralData = {
            avatar: data.avatar || '',
            name: data.name || code.toUpperCase(),
            ref_code: data.ref_code || code.toUpperCase()
          }
          this.referralLink = `${window.location.origin}/ref/${code}`
        } else {
          this.referralData = {
            avatar: '',
            name: code.toUpperCase(),
            ref_code: code.toUpperCase()
          }
          this.referralLink = `${window.location.origin}/ref/${code}`
          this.error = 'Referral page not found'
        }
      } catch (error) {
        console.error('Ошибка загрузки данных реферала:', error)
        this.error = 'Error loading referral data'
        this.referralData = {
          avatar: '',
          name: code.toUpperCase(),
          ref_code: code.toUpperCase()
        }
        this.referralLink = `${window.location.origin}/ref/${code}`
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.loading-container,
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 18px;
}

.error-container {
  color: rgb(255, 100, 100);
}
</style>

